import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { General } from '../../interfaces/general';
import { FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';

@Component({
	selector: "app-avales",
	templateUrl: "./avales.component.html",
	styleUrls: ["./avales.component.css"],
})
export class AvalesComponent implements OnInit {
	@Input() catalogos: General;
	@Input() estados: Array<any>;
	@Input() ListaDatosAval: FormGroup;
	@Input() listaCURPS: Array<any>
	@Input() aval: string;
	@Input() esConsulta: boolean = false;
	@Input() esEdicion: boolean = false
	@Input() curpSolicitante: string
	@Output() conCurp = new EventEmitter()

	tieneEmpleo: boolean = false;
	loading = false;
	tieneCURP = false;
	paises: any;
	tipoPersona = 1;
	extranjeroEs = false;
	pais: string;
	municipios: Array<any>;
	tienenOficio = []
	//initialDirectionVal;
	//initialDirecEmpresaVal;

	constructor(private serviciosGenerales: ServiciosGeneralesService,
				private snackBar: MatSnackBar) {}

	ngOnInit(): void {
		//this.initialDirectionVal =  this.ListaDatosAval.get('Direccion').value
		//this.initialDirecEmpresaVal = this.ListaDatosAval.get('Empresa_Direccion').value
		this.escucharCURP()
		this.listarMunicipios(this.ListaDatosAval.value.Personas_EntidadFederativaID)
		this.obtenerOficio()
		this.ListaDatosAval.get('Personas_Nombre').disable()
		this.ListaDatosAval.get('Personas_Nombre').disable()
		this.ListaDatosAval.get('Personas_ApellidoPaterno').disable()
		this.ListaDatosAval.get('Personas_ApellidoMaterno').disable()
		this.ListaDatosAval.get('Personas_Genero').disable()
		this.ListaDatosAval.get('Personas_EntidadFederativaID').disable()
		this.ListaDatosAval.get('Personas_MunicipioID').disable()
		console.log(this.catalogos.Oficios)
		this.tienenOficio = this.catalogos.Ocupaciones.filter(oficio => oficio.Oficio === true ? true:false)
	}

	escucharCURP() {
		this.ListaDatosAval.get("Personas_CURP")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((CURP) => {
				console.log(this.aval)
				if(CURP.length === 18) {
					if(this.aval === CURP) {
						this.openSnackBar('Un tutor no puede ser un aval','Entendido');
					}
					if(this.curpSolicitante === CURP){
						this.openSnackBar('Un Solicitante no puede ser un aval','Entendido');
					} else {
						this.obtenerdatosCURP(CURP)
					}

				} else {
					this.openSnackBar('La CURP no es valida','Entendido');
				}

			});
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
		duration: 5000,
		});
	}


	obtenerPaises(): void {
		this.serviciosGenerales.listadoPaises().subscribe((res) => {
			this.paises = res;
			const pais = this.paises.filter(
				(pais) => pais.ISO_A3 === this.pais
			);
			this.ListaDatosAval.get("Personas_PaisID").setValue(pais.ID);
		});
	}
	idEstadoMunicipioCURP (estadoID, MunicipioID) {
		const idEstadoDB = this.estados.filter(estado => +estado.Codigo === +estadoID)
		console.log(idEstadoDB)
		this.serviciosGenerales.listadoMunicipios(idEstadoDB[0].ID).subscribe((res) => {
			this.municipios = res
			const idMunicipioID = this.municipios.filter(municipio => +municipio.Codigo === +MunicipioID)
			this.ListaDatosAval.get('Personas_EntidadFederativaID').setValue(idEstadoDB[0].ID);
			this.ListaDatosAval.get('Personas_MunicipioID').setValue(idMunicipioID[0].ID);
		});
	}
	listarMunicipios(idEstado: number) {
		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res;
		});
	}
	obtenerdatosCURP(CURP: string) {
		this.tieneCURP = false;
		this.cleanForm();
		this.serviciosGenerales.obtenerDatosCURPAvales(CURP).subscribe((res) => {

				this.tieneCURP = res.Ok;

				if(this.tieneCURP && +res.Data.StateId !== 9999 && +res.Data.CityId !== 999) {
					const fechaCumpleaños = this.getFecha(res.Data.BirthDate)
					console.log(fechaCumpleaños)
					if(fechaCumpleaños > 18 && fechaCumpleaños < 65) {
						// this.ListaDatosAval.reset()

						if(res.Data.Country === "MEX") {
							this.mostrarInformacion(res.Data)
							// this.obtenerListaEstadosID()
							this.extranjeroEs = false;
						} else {
							this.pais = res.Data.Country
							this.extranjeroEs = true;
							this.mostrarInformacion(res.Data)
							this.obtenerPaises();
						}
					} else {
						this.openSnackBar('El Aval debe de tener una edad entre 18 y 65 años','Entendido')
					}
				} else {
					this.openSnackBar('Tu CURP presenta inconsistencias en el sistema, favor de ponerte en contacto con EDUCAFIN.','Entendido')
				}
		},(err => {
			console.log(err.message)
		}))
	}
	getFecha (fecha:string) {
		const datos = fecha.split('/')
		const ano = datos[2]
		const mes = datos[1]
		const dia = datos[0]

		const nuevaFecha = `${ano}-${mes}-${dia}T00:00:00`
		this.ListaDatosAval.get('Personas_FechaNacimiento').setValue(nuevaFecha)
		const fechaCumpleanos:number = this.calculateAge(new Date(+ano,+mes,+dia))
		this.ListaDatosAval.get('Personas_Edad').setValue(fechaCumpleanos)
		return fechaCumpleanos
	}
	calculateAge(birthday) {
		const ageDifMs = Date.now() - birthday.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}
	mostrarInformacion(persona) {

		console.log(persona)
		if (persona !== undefined) {
			if(persona.Country === "MEX") {
				this.idEstadoMunicipioCURP(+persona.StateId, persona.CityId)
			}
			else {
				this.ListaDatosAval.get('Personas_EntidadFederativaID').setValue(1001);
			}
			this.getFecha(persona.BirthDate)
			this.ListaDatosAval.get('Personas_Nombre').setValue(persona.Name);
			this.ListaDatosAval.get('Personas_ApellidoPaterno').setValue(persona.Lastname);
			this.ListaDatosAval.get('Personas_ApellidoMaterno').setValue(persona.Surname);
			this.ListaDatosAval.get('Personas_Genero').setValue(persona.Genre);
			this.conCurp.emit()
		}
	}
	obtenerOficio () {
		this.ListaDatosAval.get("Persona_OcupacionID")
			.valueChanges
			.subscribe((localidad : string) =>{
				this.situacionLaboralSeleccionada(localidad)
			});
	}

	situacionLaboralSeleccionada(oficio) {

		console.log(oficio)
		if (oficio === 1004 || oficio === 1002 || oficio === 1001 || oficio === 1006) {
			this.tieneEmpleo = true;
		} else {
			this.tieneEmpleo = false;
		}
	}
	onRightClick(e) {
		return false
	}

	cleanForm(){
		//this.ListaDatosAval.get('Direccion').setValue(this.initialDirectionVal);
		//this.ListaDatosAval.get('Empresa_Direccion').setValue(this.initialDirecEmpresaVal);
		this.ListaDatosAval.get('Personas_EstadoCivilID').setValue('');
		this.ListaDatosAval.get('DatosContacto_TelefonoCelular').setValue('');
		this.ListaDatosAval.get('DatosContacto_TelefonoFijo').setValue('');
		this.ListaDatosAval.get('confirmarCelular').setValue('');
		this.ListaDatosAval.get('SolicitantePersona_ParentescoID').setValue('');
		this.ListaDatosAval.get('Empresa_Telefono').setValue('');
		this.ListaDatosAval.get('Empresa_Observaciones').setValue('');
		this.ListaDatosAval.get('Persona_Ingresos').setValue('');
		this.ListaDatosAval.get('Persona_Empresa').setValue('');
		this.ListaDatosAval.get('Persona_OficioID').setValue('');
		this.ListaDatosAval.get('Persona_OcupacionID').setValue('');
		this.ListaDatosAval.get('Persona_RFC').setValue('');
	}

}
